module.exports = __webpack_public_path__ + "static/media/logo.15b0573b.png";